import axios from 'axios';
import store from '../store';

// export default class Profile {
//   constructor(axiosConfig) {
//     this.axiosConfig = axiosConfig;
//   }

//   async get(name) {
//     const axiosSvc = axios.create(this.axiosConfig);
//     let response = await axiosSvc.get(name);
//     if (
//       response &&
//       response.status >= 200 &&
//       (response.status < 300 || response.status === 304)
//     ) {
//       return response.data;
//     } else {
//       throw Error(
//         `Error getting item '${name}': ${response.status} - ${response.statusText}`
//       );
//     }
//   }
// }

function stripExtension(input) {
  return input.substr(0, input.lastIndexOf('.')) || input;
}

export default class Profile {
  constructor(axiosConfig) {
    this.axiosConfig = axiosConfig;
  }

  async get(name) {
    const axiosSvc = axios.create(this.axiosConfig);

    axiosSvc.interceptors.request.use(
      function (config) {
        var input = config.url;
        var output = input.substr(0, input.lastIndexOf('.')) || input;
        store.commit('setMessage', `Getting Profile: ${output}`);
        return config;
      },
      function (error) {
        console.log('PROFILE REQUEST error:', error);
        store.commit('setError', `REQUEST ERROR: ${error.message}`);
        return Promise.reject(error);
      }
    );

    try {
      const response = await axiosSvc.get(name, {
        validateStatus: function (status) {
          return status >= 200 && (status < 300 || status === 304);
        }
      });
      return response.data;
    } catch (error) {
      if (error) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(
          `Error getting '${name}': ${error.response.status} - ${error.response.statusText}`
        );
        store.commit(
          'setError',
          `${error.response.status} ERROR: 
          ${error.response.statusText} - 
          ${stripExtension(error.response.config.url)}`
        );
      } else if (error.request) {
        // The request was made but no response was received
        console.log('PROFILE error.request is:');
        console.log(error.request);
        store.commit(
          'setError',
          `${error.request.status} REQUEST ERROR: ${error.request.statusText} - ${error.request.config.url}`
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('PROFILE something else is wrong and error.message is:');
        console.log('Error', error.message);
      }
      console.log('error.config is:');
      console.log(error.config);
    }
  }
}
